<app-card [loading]="(loading$ | async) ?? false">
  @if (weather$ | async; as weather) {
    @if (weather.now && weather.today) {
      <div class="header">
        <h3>
          <app-text-with-icon
            name="ic_location"
            [innerHTML]="
              weather.location.locationName ??
              getGeoInfo(weather.location.lat, weather.location.lon)
            "
          />
        </h3>
      </div>

      <div class="flex gap-2 wrap">
        <span
          class="weather-icon medium"
          [class]="getWeatherIcon(weather.now.weather)"
        ></span>
        <div>
          <p>{{ "weather.now" | translate }}</p>
          <p class="large">
            {{ weather.now.temperature | temperature: "unicode" }}
          </p>
        </div>
        <div class="flex flex-1 justify-evenly weather-metrics">
          <app-text-with-icon
            name="ic_water"
            [hint]="getRainHint(weather.now.weather)"
          >
            {{ weather.now.precipitationAmount | precipitation }}
          </app-text-with-icon>
          <app-text-with-icon name="ic_wind">
            {{ weather.today.windSpeed | wind: weather.today.windDirection }}
          </app-text-with-icon>
          <app-text-with-icon name="ic_weatherstation">
            {{ $any(weather.now).airPressure | localizedNumber: "1.0-0" }} hPa
          </app-text-with-icon>
        </div>
      </div>
    }
    @if (weather.extendedForecast) {
      <table class="transparent content border-t">
        @for (day of weather.extendedForecast; track day.date) {
          <tr>
            <td>
              <b>{{ day.date | relativeDate: "day" }}</b
              ><br />
              {{ day.date | localizedDate: "d. MMM" }}
            </td>
            <td>
              <span
                class="weather-icon"
                [class]="getWeatherIcon(day.weather)"
              ></span>
            </td>
            <td>
              <app-text-with-icon>
                {{ day.minTemperature | temperature }} /
                {{ day.maxTemperature | temperature }}
              </app-text-with-icon>
            </td>
            <td>
              <app-text-with-icon name="ic_rain">
                {{ day.precipitationChance | localizedPercent }}
              </app-text-with-icon>
            </td>
          </tr>
        }
      </table>
    }
  } @else {
    {{ "weather.empty" | translate }}
  }
</app-card>
